import FeedbackView from './views/FeedbackView.vue'

export default [
  { path: '/feedback', name: 'feedback', navHide: true, component: FeedbackView, meta: { title: 'Feedback', layout: 'narrow' } },
]



// WEBPACK FOOTER //
// ./src/feedback/routes.js